import { useState } from 'react'
import { api } from '../lib/api.js'

/**
 * The pairing screen a person stands in front of with a bad remote.
 *
 * They type a short URL and an eight-character code from an unambiguous alphabet. The
 * credential itself is minted server-side and lands in an httpOnly cookie — nothing a human
 * handles here is a working credential, and nothing they type expires later than 15 minutes.
 */
export default function Tv() {
  const [code, setCode] = useState('')
  const [error, setError] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(e) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.post('/api/display/pair', { code })
      window.location.href = '/wall-view'
    } catch (err) {
      setError(err.message)
      setBusy(false)
    }
  }

  return (
    <div className="wb wb-message" style={{ padding: '3%' }}>
      <h1>Pair this screen</h1>
      <p>
        In CrewDispatch Service, go to <strong>Settings → Wall displays</strong>, add or pick this
        screen, and press <strong>Pair</strong>. Then type the code below.
      </p>
      <form onSubmit={submit} style={{ marginTop: '2rem' }}>
        <input
          type="text"
          autoFocus
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck="false"
          placeholder="TV-XXXX-XXXX"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          style={{
            fontSize: '3rem',
            textAlign: 'center',
            letterSpacing: '0.15em',
            padding: '0.6rem 1rem',
            width: '16ch',
            fontFamily: 'ui-monospace, monospace',
          }}
        />
        <div style={{ marginTop: '1.5rem' }}>
          <button className="btn primary" type="submit" disabled={busy || code.length < 8}
            style={{ fontSize: '1.5rem', padding: '0.7rem 2rem' }}>
            {busy ? 'Pairing…' : 'Pair'}
          </button>
        </div>
      </form>
      {error && (
        <p style={{ color: 'var(--red)', fontSize: '1.3rem', marginTop: '1.5rem' }}>{error}</p>
      )}
      <p style={{ fontSize: '1rem', color: 'var(--wb-ink-3)', marginTop: '2.5rem' }}>
        Codes expire after 15 minutes and work once. This screen will be read-only.
      </p>
    </div>
  )
}
